export default __webpack_public_path__ + "static/media/historyIcon.5f01b9a0.svg";